import React, { useEffect } from "react";
import SearchResultsSummary from "./SearchResultsSummary";
import FacilitiesList from "./FacilitiesList";
import PaginationBar from "./PaginationBar";
import './SearchResults.scss';

const SearchResults = (props) => {
  const limit = props.searchParams.has('limit') ? parseInt(props.searchParams.get('limit')) : props.defaultLimit;
  useEffect(() => {
    props.anchor?.current.scrollIntoView({ behavior: 'auto' });
  }, [props.anchor]);
  return (
    <div className="SearchResults">
      <SearchResultsSummary {...props} />
      <FacilitiesList {...props} />
      {(props.totalResults > limit) && <PaginationBar {...props} />}
    </div>
  );
};

export default SearchResults;
